import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { Alert, Button, Card, EmptyState, Spinner, formatDateTime } from '../../components/ui';
import { useToast } from '../../components/Toast';

export default function NannyMessages() {
  const { t } = useTranslation();
  const toast = useToast();
  const [messages, setMessages] = useState(null);
  const [error, setError] = useState('');
  const [draft, setDraft] = useState('');
  const [busy, setBusy] = useState(false);
  const bottomRef = useRef(null);

  function load() {
    api.get('/api/nanny/messages').then(({ messages: list }) => setMessages(list)).catch((err) => setError(err.message));
  }

  useEffect(load, []);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ block: 'nearest' });
  }, [messages]);

  async function send(event) {
    event.preventDefault();
    if (!draft.trim()) return;
    setBusy(true);
    try {
      await api.post('/api/nanny/messages', { body: draft.trim() });
      setDraft('');
      load();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  }

  if (error) return <Alert kind="error">{error}</Alert>;
  if (!messages) return <Spinner />;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>{t('messages.pageTitle')}</h1>
          <p className="muted">{t('messages.subtitle')}</p>
        </div>
      </div>

      <Card>
        {messages.length ? (
          <div className="chat-thread">
            {messages.map((m) => (
              <div key={m.id} className={`chat-bubble ${m.senderRole === 'nanny' ? 'is-mine' : ''}`}>
                <p>{m.body}</p>
                <small className="muted">{m.senderRole === 'admin' ? t('messages.theOffice') : t('messages.you')} · {formatDateTime(m.createdAt)}</small>
              </div>
            ))}
            <div ref={bottomRef} />
          </div>
        ) : (
          <EmptyState title={t('messages.noMessagesYet')}>{t('messages.sayHello')}</EmptyState>
        )}
        <form className="chat-composer" onSubmit={send}>
          <textarea rows={2} placeholder={t('messages.writeMessage')} value={draft} onChange={(e) => setDraft(e.target.value)} />
          <Button type="submit" loading={busy}>{t('messages.send')}</Button>
        </form>
      </Card>
    </>
  );
}
